import { render, staticRenderFns } from "./Adm_gradopolicial.vue?vue&type=template&id=455b7286"
import script from "./Adm_gradopolicial.vue?vue&type=script&lang=js"
export * from "./Adm_gradopolicial.vue?vue&type=script&lang=js"
import style0 from "./Adm_gradopolicial.vue?vue&type=style&index=0&id=455b7286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports